import { useEffect, useRef, useState } from 'react';

import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { getActiveChannel } from '@/store/slices/user/selectors';
import { getAdminContacts } from '@/store/slices/channel-admins';
import { EPermissions } from '@/types/permissions.types';

type Props = {
  includeLockedEmails?: boolean;
  roles?: EPermissions[];
  bypassIfExists?: boolean;
};

const useFetchAdminContacts = ({ includeLockedEmails = false, roles, bypassIfExists }: Props) => {
  const activeChannel = useAppSelector(getActiveChannel);

  const [loading, setLoading] = useState(false);

  const fetching = useRef(false);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (fetching.current || !activeChannel) {
      return;
    }

    fetching.current = true;
    setLoading(true);

    const fetchAdmins = async () => {
      try {
        await dispatch(getAdminContacts({ channel: activeChannel, includeLockedEmails, roles, bypassIfExists }));
      } catch (error) {
        console.error('Error fetching admins:', error);
        fetching.current = false;
      } finally {
        setLoading(false);
      }
    };

    fetchAdmins();
  }, [activeChannel, bypassIfExists, dispatch, includeLockedEmails, roles]);

  return { loading };
};

export default useFetchAdminContacts;
